document.querySelectorAll(".js-scroller-link").forEach((button) => {
	button.addEventListener("click", (e) => {
		e.preventDefault();

		let targetSection = button.getAttribute("href");

		window.lenis.scrollTo(targetSection, { offset: 1 });
	});
});
